/**
 * `cn` — junta classNames condicionais sem dependências externas.
 * Aceita strings, falsy (ignorado) e arrays. Suficiente p/ os primitivos VOS;
 * não faz merge/dedupe de conflitos Tailwind (mantemos variantes disjuntas).
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
